// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"e18c6a7a","34":"5d531d1d","112":"2e4e5c15","206":"6cf38646","239":"e68ec762","344":"4964c437","408":"e66bc109","430":"3bc2d4c2","720":"26999b3c","721":"aaf815ea","732":"b7713a2f","737":"36ec2d5d","791":"4b055bbf","977":"05146055"}[chunkId] + ".chunk.js";
};